import iCheck from 'icheck';

$(function () {
  // Radio buttons (with or without freetext choice)
  $('input.js-minerva-form-radio').each(function(){
    var $this = $(this),
        label = $this.attr("data-text"),
        // Following might be [] because we don't always use radio buttons with a freetext choice
        $wrapper = $(this).closest('.js-minerva-form-radio-wrapper'),
        $freetextContainer = $wrapper.find('.js-minerva-form-radio-freetext'),
        $freetextInput = $wrapper.find('.js-minerva-form-radio-freetext-content');

    // Prevents the browser or any translation tools from automatically translating the text associated with this radio button
    $this.attr("translate", "no");

    $this.iCheck({
      radioClass: 'skinned-radio rounded inline-block px2 py1 border',
      enabledRadioClass: 'enabled pointer',
      disabledRadioClass: 'pointer-not-allowed disabled',
      uncheckedRadioClass: 'border-lightest bg-eggshell mid',
      checkedRadioClass: 'checked border-darkest bg-mid white',
      hoverClass: 'border-darkest',
      insert: label
    });

    $this.on("ifChanged", function (event) {
      $(event.target).trigger('click'); 
    });

    if ($this.attr('data-freetext') !== undefined) {
      $this.on('ifChecked', function () {
        $freetextContainer.slideDown();
      });
      $this.on('ifUnchecked', function () {
        $freetextContainer.slideUp();
      });
      $freetextInput.on("change", function () {
        $this.val($(this).val());
      });
      $this.val($freetextInput.val());
    }
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/radio.js